import { render, staticRenderFns } from "./AuthorizedUsers.vue?vue&type=template&id=cb7f168e&scoped=true"
import script from "./AuthorizedUsers.vue?vue&type=script&lang=js"
export * from "./AuthorizedUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb7f168e",
  null
  
)

export default component.exports